import React, { Suspense, useEffect, useMemo, useRef, useState } from "react";
import Card from "components/Card";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import Loader from "components/Loader";
import styles from "../../Notes/Notes.module.scss";
import { withTranslation } from "react-i18next";
import { taskTabStatus } from "../../../../constants";
import StaffTasks from "../StaffTask";
import MyTasks from "../MyTasks";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import NotAccessible from "accountOwner/pages/ManagerDashboard/components/NotAccessible";

const AdminTask = ({
  t,
  activeTab,
  manageTab,
  tasks,
  searchValue,
  handleSearchTerm,
  officeFilter,
  handleApplyFilters,
  setOfficeFilter,
  staffFilter,
  setStaffFilter,
  resetFilter,
  statusFilter,
  priorityFilter,
  setStatusFilter,
  setPriorityFilter,
  isLoading,
  totalItems,
  setPageNumber,
  handleAction,
  deleteAction,
  isArchive,
  isFilterApply,
  accountOwnerId,
  sortBy,
  setSortBy,
  priority,
  setPriority,
  status,
  setStatus,
  handleArchiveApi,
}) => {
  const { profile, dataAccessValues, isStaff } = useAccountOwnerCommon();
  const tabName = taskTabStatus;
  const mainDivRef = useRef(null);
  const [reCalCulate, setReCalCulate] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      if (mainDivRef.current?.clientHeight) {
        setReCalCulate(true);
      }
    }, 500);
  }, []);
  const heightCalculate = useMemo(() => {
    if (isStaff && !dataAccessValues?.isAdmin && mainDivRef.current) {
      return mainDivRef.current?.clientHeight - 100;
    }
    return 500;
  }, [dataAccessValues, isStaff, reCalCulate]);
const assignedByMeTabActive=activeTab === tabName.assignedByMe
const assignedToYouTabActive=activeTab === tabName.assigntoMe
  return (
    <Card className={styles["notes_main_card"]}>
      {profile?.isAdmin ? (
        <div className="common-tabs scheduler-tabs" ref={mainDivRef}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={assignedToYouTabActive ? "active" : ""}
                onClick={() => manageTab(tabName.assigntoMe)}
              >
                {t("taskManagement.assignedToYou")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={assignedByMeTabActive ? "active" : ""}
                onClick={() => manageTab(tabName.assignedByMe)}
              >
                {t("taskManagement.assignedByYou")}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <Suspense fallback={<Loader />}>
              <TabPane tabId={1}>
                {assignedToYouTabActive && (
                  <StaffTasks
                    isArchive={isArchive}
                    isStaff={true}
                    accountOwnerId={accountOwnerId}
                  />
                )}
              </TabPane>
              <TabPane tabId={2}>
                {isStaff && !dataAccessValues?.isAdmin ? (
                  <div
                    className="not-accessible center_property"
                    style={{ height: heightCalculate }}
                  >
                    <NotAccessible
                      Message={t(
                        "dashBoard.notAccessibleModulePleaseSwitchOwner"
                      )}
                    />
                  </div>
                ) : (
                  assignedByMeTabActive && (
                    <MyTasks
                      tasks={tasks}
                      searchValue={searchValue}
                      handleSearchTerm={handleSearchTerm}
                      officeFilter={officeFilter}
                      setOfficeFilter={setOfficeFilter}
                      handleApplyFilters={handleApplyFilters}
                      staffFilter={staffFilter}
                      setStaffFilter={setStaffFilter}
                      resetFilter={resetFilter}
                      statusFilter={statusFilter}
                      priorityFilter={priorityFilter}
                      setStatusFilter={setStatusFilter}
                      setPriorityFilter={setPriorityFilter}
                      isLoading={isLoading}
                      totalItems={totalItems}
                      setPageNumber={setPageNumber}
                      handleAction={handleAction}
                      deleteAction={deleteAction}
                      isArchive={isArchive}
                      isFilterApply={isFilterApply}
                      accountOwnerId={accountOwnerId}
                      sortBy={sortBy}
                      setSortBy={setSortBy}
                      priority={priority}
                      setPriority={setPriority}
                      status={status}
                      setStatus={setStatus}
                      handleArchiveApi={handleArchiveApi}
                    />
                  )
                )}
              </TabPane>
            </Suspense>
          </TabContent>
        </div>
      ) : (
        <StaffTasks
          isArchive={isArchive}
          isStaff={true}
          accountOwnerId={accountOwnerId}
        />
      )}
    </Card>
  );
};
export default withTranslation()(AdminTask);
